"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSPrimaryCardComponent = void 0;
const core_1 = require("@angular/core");
const account_service_1 = require("../services/account.service");
const token_service_1 = require("../services/token.service");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const __1 = require("../");
const __2 = require("../");
const billing_service_1 = require("../../billing/services/billing.service");
class CSPrimaryCardComponent {
    constructor(accountDetailService, billingService, accountService, modalService, genericContentService, tokenService, helperService) {
        this.accountDetailService = accountDetailService;
        this.billingService = billingService;
        this.accountService = accountService;
        this.modalService = modalService;
        this.genericContentService = genericContentService;
        this.tokenService = tokenService;
        this.helperService = helperService;
        this.ccPaymentDetails = new core_1.EventEmitter();
        this.ccProcessingError = new core_1.EventEmitter();
        this.inputFieldsAddress = new Array();
        this.cardYear = new Array();
        this.newCardList = new Array();
        this.CcYear();
        this.cardJson();
        this.isTokenizedCC = true;
        this.count = 0;
        this.cvvBox = 'false';
    }
    // Card JSON for popup
    cardJson() {
        this.cardData = {
            name: '',
            creditCard: {
                confirmCcNumber: '',
                ccType: '',
                saveCrad: false,
                newCreditCard: false,
                addressType: 'SAVED',
                ccNumber: '',
                expMonth: 1,
                expYear: '',
                cvv: '',
                defaultCard: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: 'AL',
                zipCode: ''
            }
        };
    }
    // To make array of Exp year
    CcYear() {
        const d = new Date();
        let n = d.getFullYear();
        this.cardYear.push(n.toString());
        for (let i = 0; i <= 9; i++) {
            n = n + 1;
            this.cardYear.push(n.toString());
        }
    }
    // Get CVV generic content
    getCvvDetail() {
        this.genericContentService.getGenericContent('genericContentCVV').subscribe((data) => {
            this.cvvText = data.contentText;
            this.open(this.cvvDetails);
        }, (err) => {
            this.error = err;
        });
    }
    // To open CVV box
    clearCvv() {
        if (this.cvvBox_new !== this.cvvBox) {
            this.cvv = '';
            this.cvvBox_new = this.cvvBox;
            this.count_new = this.count;
        }
        else {
            if (this.cvvBox === 'false') {
                if (this.count_new !== this.count) {
                    this.count_new = this.count;
                    this.cvv = '';
                }
            }
        }
    }
    // Open popup
    open(content) {
        this.modalReference = this.modalService.open(content, { size: 'lg', windowClass: 'dark-modal' });
    }
    // To add new Credit card
    addCreditCard() {
        this.edit = 'no';
        this.cardJson();
        this.cardData.creditCard.expMonth = 1;
        this.cardData.creditCard.expYear = this.cardYear[0];
        this.cardData.creditCard.state = 'AL';
        this.new = true;
        this.open(this.addCreaditCard);
    }
    // Store Card Data on click of it
    storeDetails(details, count) {
        this.address = {
            city: details.city,
            state: details.state,
            addressLine2: details.addressLine2,
            zip: details.zipcode,
            addressLine1: details.addressLine1
        };
        this.firstName = details.firstName;
        this.lastName = details.lastName;
        this.payment = {
            kHashToken: details.kHash,
            creditCardNumber: details.creditCardNumber,
            expirationMonth: details.cardExpMonth,
            expirationYear: details.cardExpYear,
            creditCardType: details.creditCardType,
            creditCardId: details.creditCardDetailId,
            index: count
        };
        this.indexOfCard = count;
        this.addressSavedCard = 'billingAddrSavedCard'; // 'address'
        const card = {
            cardDetails: details,
            index: this.indexOfCard
        };
        this.ccPaymentDetails.emit(card);
    }
    // Validator for input field
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    pasteOnlyNumbers(event) {
        var _a;
        console.log('pasting only numbers');
        const pastedText = ((_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text')) || '';
        if (!/^\d*$/.test(pastedText)) {
            event.preventDefault();
        }
    }
    determineCreditCardMaskAndType(cardValue, isAutopayForm) {
        var _a;
        if (!cardValue) {
            return;
        }
        const cardNumberFormat = this.billingService.creditCardMaskAndType(cardValue, isAutopayForm);
        if (cardNumberFormat !== undefined) {
            this.creditCardMask = (_a = cardNumberFormat === null || cardNumberFormat === void 0 ? void 0 : cardNumberFormat.cardSpacingPatterns) === null || _a === void 0 ? void 0 : _a.cardSpacingPattern;
        }
    }
    // To clear popup data and changing the flags
    clearPopup() {
        this.save_ad = 'no';
        if (!this.newCardData) {
            this.cvvBox = 'false';
            this.new = false;
        }
        this.edit = 'no';
        if (this.modalReference) {
            this.modalReference.close();
        }
    }
    // Populate card data to popup
    saveCardEdit(details) {
        this.cardJson();
        this.getEditSavedCardContent();
        this.edit = 'yes';
        this.cardData.name = details.firstName + ' ' + details.lastName;
        this.cardData.creditCard.ccNumber = details.creditCardNumber;
        this.cardData.creditCard.confirmCcNumber = details.creditCardNumber;
        this.cardData.creditCard.expMonth = parseInt(details.cardExpMonth, 10);
        this.cardData.creditCard.expYear = details.cardExpYear;
        this.cardData.creditCard.cardType = this.tokenService.getDisplayCardType(details.creditCardType);
        if (this.paymentDetails && this.paymentDetails.paymentType === 'credit' && details.defaultCard) {
            this.cardData.creditCard.defaultCard = true;
        }
        this.save_ad = 'yes';
        this.open(this.addCreaditCard);
    }
    // Open delete confirmation popup
    deletePopup(card) {
        this.deleteId = card.creditCardDetailId;
        this.open(this.deleteCardO);
    }
    getTokenServiceErrorMessage(error) {
        const errorJson = this.tokenErrorMessage;
        let errorMessage;
        if (error.code !== undefined && error.code !== null) {
            errorMessage = errorJson[error.code];
        }
        else {
            errorMessage = errorJson['000'];
        }
        if (errorMessage !== undefined && errorMessage !== null) {
            const errorMap = {
                'code': error.code,
                'message': errorMessage
            };
            this.error = errorMap;
            this.loader = false;
        }
        else {
            this.error = error;
            this.loader = false;
        }
    }
    getEditSavedCardContent() {
        this.genericContentService.getGenericContent('genericEditSavedCreditCardInfo').subscribe((data) => {
            this.editSavedCreditCardContent = data === null || data === void 0 ? void 0 : data.contentText;
        }, (err) => {
            this.error = err;
        });
    }
}
exports.CSPrimaryCardComponent = CSPrimaryCardComponent;
//# sourceMappingURL=primarycard.component.js.map